import RouteUrls from '@/app/root/enums/RouteUrls';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import SESSION from '../apiUrls';
import userFields from '@/app/modules/users/monetic/fields/userFields';

/**
 * @param responseData response.data object
 * @param responseData.uuid string
 * @param responseData.email string
 * @param responseData.roles string
 * @param responseData.organization string
 * @param responseData.createdAt string
 * @param responseData.updatedAt string
 * @param responseData.permissions array
 * @param responseData.isPreludd boolean
 * @param responseData.isDirectPreluddClient boolean
 *
 * @param response
 * @returns Mapped data object
 */
function mapResponseData(response) {
    const data = {};

    data[userFields.UUID.key] = response[userFields.UUID.key];
    data[userFields.EMAIL.key] = response[userFields.EMAIL.key];
    data[userFields.ROLES.key] = response[userFields.ROLES.key];
    data[userFields.ORGANIZATION_UUID.key] = response[userFields.ORGANIZATION_UUID.key];
    data[userFields.CREATED_AT.key] = response[userFields.CREATED_AT.key];
    data[userFields.UPDATED_AT.key] = response[userFields.UPDATED_AT.key];
    data[userFields.PROFILE_PERMISSIONS.key] = response[userFields.PROFILE_PERMISSIONS.key];
    data[userFields.IS_PRELUDD.key] = response[userFields.IS_PRELUDD.key];
    data[userFields.IS_DIRECT_PRELUDD_CLIENT.key] = response[userFields.IS_DIRECT_PRELUDD_CLIENT.key];

    return data;
}

const queryGetSession = (enabled = true) => {
    return {
        queryKey: [SESSION.SESSION.queryKey],
        queryFn: async () => {
            const response = await client.get(SESSION.SESSION.url);
            return mapResponseData(response.data);
        },
        enabled: enabled,
        refetchOnWindowFocus: !(window.location.href.includes(RouteUrls.LOGIN.url)) // refetch the data when the user is connected and the window is focused -
    };
};

export default queryGetSession;